import { BookmarkCheck } from "lucide-react";

import { useReadNotification } from "@/entities/notification/api";
import { Button } from "@/shared/ui/button";
import { Spinner } from "@/shared/ui/spinner";

interface ReadNotificationButtonProps {
  id: string;
}

export const ReadNotificationButton = ({ id }: ReadNotificationButtonProps) => {
  const { mutateAsync, status } = useReadNotification();

  const handleReadNotification = async () => {
    try {
      await mutateAsync({ id });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Button
      size="icon"
      variant="ghost"
      disabled={status === "pending"}
      onClick={handleReadNotification}
    >
      {status === "idle" ? <BookmarkCheck /> : <Spinner />}
    </Button>
  );
};
